<template>
  <div class="second-layout">
    <div
      class="infogram-embed"
      data-id="74f9c211-67da-467e-8538-43c3b50c16b5"
      data-type="interactive"
      data-title="LP_Burle Onda Circular"
    ></div>
    <script type="application/javascript">
      !(function (e, i, n, s) {
        var t = 'InfogramEmbeds',
          d = e.getElementsByTagName('script')[0];
        if (window[t] && window[t].initialized)
          window[t].process && window[t].process();
        else if (!e.getElementById(n)) {
          var o = e.createElement('script');
          (o.async = 1),
            (o.id = n),
            (o.src = 'https://e.infogram.com/js/dist/embed-loader-min.js'),
            d.parentNode.insertBefore(o, d);
        }
      })(document, 0, 'infogram-async');
    </script>
  </div>
</template>

<script>
export default {
  name: 'OndaCircular',
};
</script>

<style lang="sass" scoped>
.second-layout
  padding-top: 71px
  @media screen and (max-width: 959px)
    padding-top: 55px
</style>
